module.exports = __webpack_public_path__ + "static/digital-art-d2551af1208b6a02354a90af9cd039d7.jpg";